import { SERVER_EMAIL_NOTIFY, USER_INFO_EMAIL_NOTIFY } from "../../../constans";
import RSAA from "redux-api-middleware/es/RSAA";
import userInfoSave from "../../../utils/userInfoSave";
import {
  EMAIL_NOTIFY_USER_FAILURE,
  EMAIL_NOTIFY_USER_REQUEST,
  EMAIL_NOTIFY_USER_SUCCESS,
} from "../../../actions/login/LoginType";

const GetEmailUserAction = (token) => ({
  [RSAA]: {
    endpoint: `${SERVER_EMAIL_NOTIFY}/api/users/me`,
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
    types: [
      EMAIL_NOTIFY_USER_REQUEST,
      {
        type: EMAIL_NOTIFY_USER_SUCCESS,
        payload: async (action, state, res) => {
          const contentType = res.headers.get("Content-Type");
          if (contentType && ~contentType.indexOf("json")) {
            await res.json().then((json) => {
              userInfoSave(json.data, USER_INFO_EMAIL_NOTIFY);
            });

            return {
              code: 0,
              type: EMAIL_NOTIFY_USER_SUCCESS,
            };
          }
        },
      },
      EMAIL_NOTIFY_USER_FAILURE,
    ],
  },
});

export { GetEmailUserAction };
